import { DocumentUid, EnterpriseHandle, OrganizationHandle, Slug, UserHandle, DocumentName } from "@buildwithflux/models";
import { z } from "zod";
export const GetDatasheetUrlRequestData = z.object({
    projectUid: DocumentUid,
});
/**
 * Response schema for getDatasheetUrl function.
 * Returns both the original datasheet URL (from distributor) and the cached URL (in our GCS).
 */
export const GetDatasheetUrlResponseData = z
    .object({
    /** The original URL from the distributor */
    original: z.string(),
    /** The cached URL pointing to our GCS */
    cached: z.string(),
})
    .nullish()
    .transform((s) => s ?? undefined);
export const GetProjectUidForUrlRequestOldData = z.object({
    ownerHandle: UserHandle, // or OrganizationPublicHandle
    slug: z.string().min(1),
});
export const GetProjectUidForUrlRequestNewData = z.object({
    pathname: z.string().startsWith("/").min(2),
});
export const GetProjectUidForUrlResponseData = DocumentUid.nullish().transform((s) => s ?? undefined);
export const RenameProjectRequestData = z.object({
    documentUid: DocumentUid,
    requestedName: DocumentName,
});
export const GetProjectNameRequestData = z.object({
    ownerHandle: UserHandle.or(OrganizationHandle),
    enterpriseOwnerHandle: EnterpriseHandle.nullish().transform((s) => s ?? undefined),
    requestedName: DocumentName,
});
export const ProjectNameResult = z.object({
    name: DocumentName,
    slug: Slug,
});
//# sourceMappingURL=projects.js.map